import type { CanBePorscheApproved } from "@slfinrtl/ui-bff-routes"

export const isDealerDecisionValid = (view: {
	canBePorscheApproved: CanBePorscheApproved
	dealerDecisionPorscheApproved: boolean | undefined
}): boolean => {
	return !view.dealerDecisionPorscheApproved || view.canBePorscheApproved.ok
}
